<template>
  <import-charge-tab lob="SE" />
</template>

<script>
import importChargeTab from '@/components/Cargo/Job/importCharge/importChargeTab'

export default {
  name: 'ImportChargeSE',
  components: { importChargeTab }
}
</script>
